<ng-container *ngIf="transactionalDataState$ | async as state">
    <div class="workingPlan-container mat-elevation-z8">
        <div class="table-header">
            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value"
                        (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table matSort [dataSource]="dataSource">

                <ng-container matColumnDef="articleNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.workingPlan.articleNr.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.articleNr}} </td>
                </ng-container>

                <ng-container matColumnDef="planningSize">
                    <th mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header>{{ "app.model.workingPlan.planningSize.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.planningSize | number: '1.0-2' : 'de-DE'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="productionSize">
                    <th mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header>{{ "app.model.workingPlan.productionSize.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.productionSize | number: '1.0-2' : 'de-DE'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="constantTimeMinutes">
                    <th mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header>{{ "app.model.workingPlan.constantTimeMinutes.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.constantTimeMinutes / 60 | number: '1.0-2' : 'de-DE'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="linearTimeMinutes">
                    <th mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header>{{ "app.model.workingPlan.linearTimeMinutes.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.linearTimeMinutes / 60 | number: '1.0-2' : 'de-DE'}}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="state.workingPlanColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: state.workingPlanColumns;"></tr>

            </table>
            <mat-paginator showFirstLastButtons [pageSizeOptions]="[20, 50]"></mat-paginator>
        </div>
    </div>
</ng-container>
